import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedUploadURLForSurveyRulesRPC } from "./getPresignedUploadUrlForSurveyRulesRPC";

export class GetPresignedUploadURLForSurveyRulesRPCClientImpl extends GetPresignedUploadURLForSurveyRulesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedUploadURLForSurveyRulesRPC.Request): Promise<LeoRPCResult<GetPresignedUploadURLForSurveyRulesRPC.Response, GetPresignedUploadURLForSurveyRulesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetPresignedUploadURLForSurveyRules",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedUploadURLForSurveyRulesRPC.ResponseDTO,
      GetPresignedUploadURLForSurveyRulesRPC.Errors.ErrorsDTO,
      GetPresignedUploadURLForSurveyRulesRPC.Response,
      GetPresignedUploadURLForSurveyRulesRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetPresignedUploadURLForSurveyRules",
      GetPresignedUploadURLForSurveyRulesRPC.Response.fromDTO,
      GetPresignedUploadURLForSurveyRulesRPC.Errors.fromDTO
    );
  }
}
